import '@babel/polyfill'; //TODO: remove this once polyfill is set up in webpack
import Vue from 'vue';
import ModelFixApp from 'rrViewComponents/Model/Fix/ModelFixAppComponent/model-fix-app';
import VueDataMapMixin from 'js/lib/vue/mixins/vue-data-map-mixin';
import VueSwMixin from 'js/lib/vue/mixins/vue-sw-mixin';
import { CollapsePlugin } from 'bootstrap-vue';

export default function ($fragment) {
  const appDataKey = 'model-fix-app';
  const autoloaderSelector = `[data-sw-${appDataKey}]`;

  $fragment.swFindWithSelf(autoloaderSelector).each((i, el) => {
    const vueAppOptions = {
      el: el,

      mixins: [VueDataMapMixin, VueSwMixin],

      components: {ModelFixApp},

      data: () => ({
        modelId: null,
        modelFileId: null,
        status: null,
        componentProps: null
      }),

      created() {
        const appData = this.$sw.data[appDataKey];
        const dataAttrNames = Object.keys(this.$data);
        if (appData) {
          this.mapObjectPropertiesToVueData(appData, dataAttrNames);
        }
      }
    };

    Vue.use(CollapsePlugin);

    new Vue(vueAppOptions);
  });
}
